import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { shareReplay } from 'rxjs/internal/operators/shareReplay';
import { EmployeeLeaveModel } from '../models/EmployeeLeaveModel';
import { EmployeeLeaveWidgetDataModel } from '../models/non-master-model/EmployeeLeaveWidgetDataModel';



@Injectable({
    providedIn: 'root'
})

export class EmployeeLeaveService {

    constructor(private http: HttpClient) { }

    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/EmployeeLeave';

    getAllData() {
        return this.http.get<EmployeeLeaveModel[]>(this.baseurl + this.pathName).pipe(shareReplay(1));
    }

    getEmployeeLeaveByDate(leaveDate: string,shopID:string) {
        return this.http.get<EmployeeLeaveWidgetDataModel[]>(this.baseurl + this.pathName+ '/getEmployeeLeaveByDate/'+leaveDate+"/"+shopID);
    }

    

    // getAllDataByShopID(shopID: string, date: string, clthConsultNumber: string) {
    //     return this.http.get<tBedModel[]>(this.baseurl + this.pathName + '/ByShopID/' + shopID + '/' + date + '/' + clthConsultNumber);
    // }

    getDataById(id: string) {
        return this.http.get<EmployeeLeaveModel>(this.baseurl + this.pathName + '/' + id);
    }

    addData(data: EmployeeLeaveModel) {
        return this.http.post(this.baseurl + this.pathName, data).pipe(shareReplay(1));
    }

    addData_DateRange(startDate : string , endDate : string , data: EmployeeLeaveModel) {
        return this.http.post(this.baseurl + this.pathName +"/DateRange/"+ startDate +"/"+endDate, data).pipe(shareReplay(1));
    }


    deleteData(data: EmployeeLeaveModel) {
        return this.http.post(this.baseurl + this.pathName + '/deleteModel',data);
    }

    // updateData(data: tBedModel) {
    //     //   data.lastModifyLoginName = "2";
    //     return this.http.put(this.baseurl + this.pathName + '/' + data.shopID, data);
    // }
}